import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import { Modal, Checkbox, Row, Col, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

let searchTimeout = null;


class TripEditPessengerContact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            passengers: props.passengers,
            contacts: [],
            filteredContacts: []
        };
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.type === "contact") {
            this.setState({ filteredContacts: nextProps.contacts, contacts: nextProps.contacts })
        }
    }


    onChangeCheckBox = (item) => {
        this.props.addPassenger(item)
    }

    onChecked = (item) => {

        let { passengers } = this.props;

        if (passengers.some(e => e.phoneNumber === item.phoneNumber)) {
            return true
        } else {
            return false
        }

    }

    onChangeSearchbox = (e) => {

        let { contacts, filteredContacts } = this.state;

        let query = e.target.value;

        if (this.props.type === "contact") {
            filteredContacts = contacts.filter(item => (
                item.name.toLowerCase().includes(e.target.value) ||
                item.lastname.toLowerCase().includes(e.target.value)
            ));

            this.setState({ filteredContacts })
        } else {

            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                this.getUsers(query)
            }, 500)

        }
    }

    getUsers = (query) => {

        let endpoint = { keyOne: "customer/users" };

        this.props.dispatch(actions.definitions.getData({
            ...endpoint,
            filter: { q: query }
        })).then(response => {
            this.setState({
                filteredContacts: response
            });
        })
    }



    render() {

        const { handleToggle, isModalContactList } = this.props;
        const { filteredContacts } = this.state;

        return (

            <Modal
                className='select-contact-list-modal'
                title="Kişilerden Seç" centered open={isModalContactList} onOk={handleToggle} onCancel={handleToggle}
                maskClosable={false}
                footer={null}
                destroyOnClose={true}
            >
                <Row style={{ marginBottom: 20 }}>
                    <Input
                        placeholder={this.props.type === 'contact' ? 'Kişi listesi ve Genel kişi listesinde ara...' : 'Üye kullanıcılarda ara...'}
                        width={300}
                        prefix={<SearchOutlined />}
                        onChange={(e) => this.onChangeSearchbox(e)}
                    ></Input>
                </Row>

                <Row>
                    {
                        filteredContacts.map(item => {
                            return <Col xs={12} sm={12} md={12} lg={12} xl={12} key={item.phoneNumber}>
                                <Checkbox
                                    defaultChecked={this.onChecked(item)}
                                    className='checkbox'
                                    onChange={(e) => this.onChangeCheckBox(item, e)}
                                    key={item.phoneNumber}
                                >
                                    {`${item.name} ${item.lastname}`}
                                </Checkbox>
                            </Col>
                        })
                    }

                </Row>
            </Modal>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripEditPessengerContact);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripEditPessengerContact.js